/**
 * Wait for fonts to load and execute callback
 * @param {Function} callback - Function to execute after fonts load
 */
export const waitForToLoad = (callback) => {
  if (!document.fonts) {
    // Fonts API not available, call callback immediately
    callback();
    return;
  }

  const maxRetries = 3;
  let retryCount = 0;

  const attemptFontLoad = () => {
    console.log(document.fonts.ready);
    document.fonts.ready
      .then(() => {
        // Fonts loaded successfully
        callback();
      })
      .catch(() => {
        // Font loading failed, retry
        retryCount += 1;

        if (retryCount < maxRetries) {
          // Retry after a short delay
          setTimeout(attemptFontLoad, 500);
        } else {
          // Max retries exceeded, fallback to callback
          callback();
        }
      });
  };

  // Start first attempt
  attemptFontLoad();
};

/**
 * Load fonts by hiding content until ready
 * @param {Function} onReady - Callback when fonts are ready
 */
export const loadFont = (onReady) => {
  // Hide content while fonts load
  document.documentElement.style.opacity = '0';
  document.documentElement.style.transition = 'opacity 0.3s ease-in-out';

  // Wait for fonts then show content
  waitForToLoad(() => {
    document.documentElement.style.opacity = '1';
    onReady();
  });
};
